import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';

@Injectable()
export class MessagingService {
  private messaging;
  private messageSource = new Subject();
  currentMessage = this.messageSource.asObservable();

  constructor(
    private afs: AngularFirestore,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    const iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!iOS && !isSafari) {
      this.messaging = firebase.messaging();
    }
  }

  // get permission to send messages
  getPermission(user) {
    this.messaging
      .requestPermission()
      .then(() => {
        return this.messaging.getToken();
      })
      .then(token => {
        console.log(token);
        this.saveToken(user, token);
      })
      .catch(err => {
        console.log('Unable to get permission to notify.', err);
      });
  }

  // Listen for token refresh
  monitorRefresh(user) {
    this.messaging.onTokenRefresh(() => {
      this.messaging
        .getToken()
        .then(refreshedToken => {
          console.log('Token refreshed.');
          this.saveToken(user, refreshedToken);
        })
        .catch(err => console.log(err, 'Unable to retrieve new token'));
    });
  }

  // used to show message when app is open
  receiveMessages() {
    this.messaging.onMessage(payload => {
      console.log('Message received. ', payload);
      const snackBarRef = this.snackBar.open(payload.notification.body, 'Go', {
        duration: 5000,
        verticalPosition: 'top'
      });
      snackBarRef.onAction().subscribe(() => {
        this.router.navigate([
          payload.notification.click_action.replace(
            'https://dynasty-contract-ff3.firebaseapp.com/',
            ''
          )
        ]);
      });
      this.messageSource.next(payload);
    });
  }

  // save the permission token in firestore
  private saveToken(user, token): void {
    const currentTokens = user.fcmTokens || [];
    console.log(currentTokens, token);

    // If token does not exist in firestore, update db
    if (currentTokens.indexOf(token) < 0) {
      const userRef = this.afs
        .collection('owners')
        .doc(localStorage.getItem('dffUser'));
      currentTokens.push(token);
      userRef.update({ fcmTokens: currentTokens });
    }
  }
}
